export default __webpack_public_path__ + "static/media/logo.59588cc6.png";